/**
 * 部署ツリーの親子連動方法
 */
export enum TreeSelectionLinkage {
    // チェック付けたらすべての子にチェックを付ける。チェックを外す場合、Shift押下していたらすべての子のチェックを外す。
    Normal,
    // チェック付けたらすべての子のチェックを付ける。チェックを外したらすべての子のチェックを外す。
    SyncDescendants,
    // チェックを付けたらすべての子のチェックを付ける。チェックを外したらすべての親のチェックを外す。
    SyncAncestors,
}